import {useIntl} from 'react-intl'
import {Link} from 'react-router-dom'
import DuplicateBarcodeDetails from './DuplicateBarcodeDetails'
import '../../common/hisbeh-integrity.css'

const DuplicateBarcode = () => {
  const {formatMessage} = useIntl()

  return (
    <div className='hib-root'>
      <Link to='/request-add-products' className='hib-breadcrumb'>
        <i className='fas fa-arrow-left' aria-hidden='true' />
        {formatMessage({id: 'add_single_product'})}
      </Link>
      <h1 className='hib-title'>{formatMessage({id: 'update_prod_bulk'})}</h1>

      {/* Multi-supplier (B9): clarify what "duplicate" means here — selling
          the same product as another supplier is normal (manage that from My
          Offers); this page only resolves true catalog barcode clashes. */}
      <div className='alert alert-light-primary d-flex align-items-center' role='note'>
        <i className='fas fa-info-circle me-2' aria-hidden='true' />
        <span>{formatMessage({id: 'duplicate_barcode_ms_note'})}</span>
      </div>

      <DuplicateBarcodeDetails />
    </div>
  )
}

export default DuplicateBarcode
